import { Component, ViewEncapsulation } from '@angular/core'

@Component({
  selector: 'hs-app-header-button-container',
  templateUrl: './app-header-button-container.component.html',
  styleUrls: ['./app-header-button-container.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class AppHeaderButtonContainerComponent {}
